import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { appsettings } from "@/settings/appsettings";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectorEjercito',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

const ejercitos = [...appsettings.armies].sort((a, b) =>
  a.name.localeCompare(b.name)
);

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createBlock(_component_v_autocomplete, {
    "model-value": _ctx.modelValue,
    items: _unref(ejercitos),
    "item-title": "name",
    "item-value": "name",
    label: "Ejército",
    "auto-select-first": "",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = valor => emit('update:modelValue', valor))
  }, {
    item: _withCtx(({ item, props: itemProps }) => [
      _createVNode(_component_v_list_item, _mergeProps(itemProps, {
        subtitle: item.raw.band === 'good' ? 'Luz' : 'Oscuridad'
      }), null, 16, ["subtitle"])
    ]),
    _: 1
  }, 8, ["model-value", "items"]))
}
}

})